<template>
  <div>
    <div class="card-box">
      <b-row class="align-items-center">
        <b-col md="12">
          <div class="flex align-items-center justify-content-between">
            <h4>ID Card verification</h4>
            <c-switch
              class="mx-1"
              color="primary"
              v-model="localDataObj.enable"
              label
              variant="pill"
              data-on="|"
              data-off="|"
            />
          </div>
        </b-col>
      </b-row>
      <b-row v-if="localDataObj.enable" class="align-items-center mt-2">
        <b-col md="2"><h5>Methods</h5></b-col>
        <b-col md="4">
          <b-form-radio-group
            id="radio-group-2"
            @change="changeVerificationMode"
            v-model="selectedMode"
            name="radio-sub-component"
            class="mt-2"
          >
            <b-form-radio value="manual" name="radio-size" size="lg"
              ><p class="ml-2 small-text">Manual</p>
            </b-form-radio>
            <b-form-radio value="automated" name="radio-size" size="lg"
              ><p class="ml-2 small-text">Automated</p>
            </b-form-radio>
          </b-form-radio-group>
        </b-col>
        <b-col md="5" class="flex justify-content-between">
          <h5>Document Types</h5>
          <b-col md="8">
            <eb-select
              type="select"
              :options="allDocs"
              label="label"
              id="docs"
              placeholder="Document"
              class="mt-0 currencyNameDropdown mb-0 ml-3"
              v-model="selectedDoc"
              :selected="selectedDoc"
              @input="onSelectCode"
            ></eb-select>
          </b-col>
        </b-col>
        <b-col md="1" class="text-center"
          ><img
            src="@/assets/images/add_icon.png"
            @click="addDocConfig"
            alt
                class="add-icon"
        /></b-col>
      </b-row>
      <div
        v-for="(type, ind) in Object.keys(docDataObj)"
        :key="ind"
        class="mt-2"
      >
        <b-row v-if="type === 'manual'">
          <b-col md="12" v-if="ind">
            <div class="p-2">
              <h4 class="or-divider">OR</h4>
            </div>
          </b-col>
          <b-col md="2"
            ><h5>{{ docDataObj[type].documentType }}</h5></b-col
          >
          <b-col md="3"></b-col>
          <b-col md="3"></b-col>
          <b-col md="3"
            ><eb-select
              type="select"
              :options="allImageTypes"
              label="label"
              id="ResourceCode"
              placeholder="Allowed Image Types"
              class="mt-0 currencyNameDropdown mb-0"
              v-model="docDataObj[type].allowedImageType"
              :selected="docDataObj[type].allowedImageType"
              @input="(e) => onSelectImgType(e.value, type)"
            ></eb-select
          ></b-col>
          <b-col md="1" class="text-center"
            ><img
              src="@/assets/images/Trash.png"
              alt
                class="trash-icon"
              @click="RemoveType(type)"
          /></b-col>
        </b-row>
        <b-row class="align-items-center" v-if="type === 'automated'">
          <b-col md="12" v-if="ind">
            <div class="p-2">
              <h4 class="or-divider">OR</h4>
            </div>
          </b-col>
          <b-col md="2"
            ><h5>{{ docDataObj[type].documentType }}</h5></b-col
          >
          <b-col md="3">
            <c-input
              inputId="check4"
              required
              labelText="Number of Characters"
              v-model="docDataObj[type].no_of_characters"
              cssClass="kyc-input-tall"
            />
          </b-col>
          <b-col md="3">
            <c-input
              inputId="check3"
              required
              labelText="Secret Key"
              v-model="docDataObj[type].secret_key"
              cssClass="kyc-input-tall"
            />
          </b-col>
          <b-col md="3">
            <c-input
              inputId="check2"
              required
              labelText="Password"
              v-model="docDataObj[type].password"
              cssClass="kyc-input-tall"
            />
          </b-col>
          <b-col md="1" class="text-center"
            ><img
              src="@/assets/images/Trash.png"
              alt
                class="trash-icon"
              @click="RemoveType(type)"
          /></b-col>
          <b-col md="2"></b-col>
          <b-col>
            <c-input
              inputId="check1"
              required
              labelText="Enter API Url"
              v-model="docDataObj[type].api"
          /></b-col>
          <b-col md="1"></b-col>
        </b-row>
      </div>
      <b-row class="mt-4 mb-3" v-if="Object.keys(docDataObj).length">
        <b-col md="3"></b-col>
        <b-col md="3">
          <b-button variant="outline-danger" class="tc-btn cancel-btn"
            >CANCEL</b-button
          ></b-col
        >
        <b-col md="3">
          <b-button variant="primary" class="tc-btn" @click="updateConfig"
            >SAVE</b-button
          >
        </b-col>
        <b-col md="3"></b-col>
      </b-row>
    </div>
  </div>
</template>

<script>
import ebSelect from "@/components/FormElements/Select.vue";
import { Switch as cSwitch } from "@coreui/vue";
import cInput from "@/components/Common/CustomInput";
export default {
  name: "idCardVerification",
  components: {
    cSwitch,
    ebSelect,
    cInput,
  },
  props: {
    dataObj: {
      default: () => {},
      type: Object,
    },
    userType: {
      default: "",
      type: String,
    },
  },
  data() {
    return {
      selectedMode: "",
      allDocs: ["Passport", "Aadhar", "Voter ID"],
      selectedDoc: "",
      localDataObj: {},
      docDataObj: {},
      allImageTypes: [
        { label: "JPG", value: "jpg" },
        { label: "JPEG", value: "jpeg" },
        { label: "PNG", value: "png" },
      ],
    };
  },
  computed: {
    userId() {
      return JSON.parse(sessionStorage.getItem("userLogin"))["_id"];
    },
  },
  methods: {
    syncLocalState() {
      this.localDataObj = JSON.parse(JSON.stringify(this.dataObj || {}));
      this.docDataObj = {};
      Object.keys(this.localDataObj).forEach((el) => {
        if (typeof this.localDataObj[el] === "object" && this.localDataObj[el]) {
          this.docDataObj[el] = { ...this.localDataObj[el] };
        }
      });
    },
    RemoveType(method) {
      if (Object.keys(this.docDataObj).length === 1) {
        this.docDataObj = Object.assign({});
      }
      Object.keys(this.docDataObj).forEach((el) => {
        if (el !== method) {
          let obj = {};
          obj[el] = { ...this.docDataObj[el] };
          this.docDataObj = Object.assign({}, obj);
        }
      });
    },
    onSelectImgType(val, type) {
      this.docDataObj[type].allowedImageType = val;
    },
    addDocConfig() {
      this.docDataObj[this.selectedMode] = {};
      if (this.selectedMode === "manual") {
        this.docDataObj[this.selectedMode] = {
          documentType: this.selectedDoc.toLocaleUpperCase(),
          allowedImageType: "",
        };
        this.docDataObj = Object.assign({}, this.docDataObj);
      } else {
        this.docDataObj[this.selectedMode] = {
          no_of_characters: "",
          secret_key: "",
          password: "",
          api: "",
          documentType: this.selectedDoc.toUpperCase(),
        };
      }
      this.selectedMode = this.selectedDoc = "";
    },
    async updateConfig() {
      let payload = {
        kycVerification: {},
      };
      payload.kycVerification[this.userType] = {
        idCard: { ...this.docDataObj, enable: this.localDataObj.enable },
      };
      try {
        await this.$store.dispatch("tenant/updateKycConfig", {
          id: this.userId,
          data: { ...payload },
        });
      } catch (error) {
        console.error(error);
      }
    },
  },
  mounted() {
    this.syncLocalState();
  },
  watch: {
    dataObj: {
      deep: true,
      handler() {
        this.syncLocalState();
      },
    },
  },
};
</script>

<style scoped>
.or-divider {
  color: var(--primary);
}

.add-icon {
  cursor: pointer;
  width: 90%;
}

.trash-icon {
  cursor: pointer;
  width: 28px;
  height: 28px;
  min-width: 20px;
  min-height: 20px;
}

::v-deep .kyc-input-tall {
  height: 50px !important;
  min-height: 50px !important;
}

@media (max-width: 991px) {
  .add-icon {
    max-width: 40px;
    width: 40px;
    margin-top: 10px;
  }
  .trash-icon {
    max-width: 40px;
    width: 40px;
    margin-top: 10px;
    margin-bottom: 10px;
  }
  .cancel-btn {
    margin-bottom: 10px;
  }
}
</style>
